<template>
  <div v-if="authorizedNavLinks && shouldDisplay" id="mainNav" :style="{ backgroundColor: navColor }">
    <!-- Collapsed nav for mobile -->
    <BNavbarNav id="mainNav__hamburgerMenu" class="d-lg-none">
      <BDropdown variant="link" toggle-class="nav-link">
        <template #button-content>
          <font-awesome-icon
            id="mainNav__hamburgerMenu__icon"
            icon="bars"
            @click="closeUserNav()"
            />
        </template>
        <BDropdownItem
          v-for="page in filteredMobilePages"
          :key="page.name"
          :to="page.href"
          tag="RouterLink"
          :target="page.newTab ? '_blank' : null"
          >
          {{ page.name }}
        </BDropdownItem>
      </BDropdown>
    </BNavbarNav>
    <BNavbar class="left-items">
      <div id="mainNav__logo">
        <router-link to="/home-apps" class="home-link">
          <img class="nav__barco--logo" src="@/assets/images/logoSmall.png" alt="barco logo" />
        </router-link>
      </div>
      <BNavbarToggle target="nav-collapse" />
      <BCollapse id="nav-collapse" is-nav>
        <BNavbarNav class="nav__dropdown--options d-lg-flex d-none">
          <button
            @mouseenter="openDropdown(group.label)"
            @mouseleave="delayedCloseDropdown()"
            @click="NavClicked(group.label)"
            :show="hoveredDropdown == group.label"
            class="mainNav__header animated fadeIn"
            v-for="group in filteredGroupedPages"
            :key="group.label"
          >
            {{ group.label }}
            <font-awesome-icon v-if="hoveredDropdown == group.label || clickedDropdown == group.label" class="mainNav__dropdown-icon" icon="caret-up" />
            <font-awesome-icon v-else class="mainNav__dropdown-icon" icon="caret-down" />
            <div
              v-if="hoveredDropdown == group.label || clickedDropdown == group.label"
              id="mainNav__executive"
            >
              <div v-for="(section, columnIndex) in group.columns" :key="columnIndex" class="mega-menu-column" :class="{ 'with-divider' : section.divider }">
                <div v-if="section.header" class="mega-menu-header"><span>{{ section.header != '-' ? section.header : '' }}</span></div>
                <router-link v-for="page in section.pages" :key="page.name" class="mainNav__item" :to="page.href" :target="page.newTab ? '_blank' : null" @click="hoveredDropdown = null"
                >{{ page.name }}</router-link
                >
              </div>
            </div>
          </button>
        </BNavbarNav>
        <BNavbarNav class="mid-items mx-auto d-lg-flex d-none">
          <div v-for="group in frequentPages" :key="group.label">
            <div v-if="authorizedNavLinks.includes('onboarding') || authorizedNavLinks.includes('offboarding')">
              <button
                @mouseenter="openDropdown('Rental')"
                @mouseleave="delayedCloseDropdown()"
                @click="NavClicked('Rental')"
                class="mainNav__header mainNav__rental"
                v-if="group.label == 'Rental'"
                >
                {{ group.label }}
                <font-awesome-icon v-if="hoveredDropdown == 'Rental' || clickedDropdown == 'Rental'" class="mainNav__dropdown-icon" icon="caret-up" />
                <font-awesome-icon v-else class="mainNav__dropdown-icon" icon="caret-down" />
                <div
                  v-if="hoveredDropdown == group.label || clickedDropdown == group.label"
                  id="mainNav__executive"
                  ><div v-for="page in group.pages" :key="page.permissions">
                  <router-link v-if="page.permissions.some(perm => authorizedNavLinks.includes(perm))" class="mainNav__item mega-menu-column" :to="page.href" @click="hoveredDropdown = null"
                  >{{ page.name }}</router-link
                  ></div>
                </div>
              </button>
            </div>
          </div>
          <div v-for="page in frequentPages" :key="page.name">
            <div v-if="!page.label && authorizedNavLinks">
              <router-link v-if="page.permissions.some(perm => authorizedNavLinks.includes(perm))" class="mainNav__header" :to="page.href">{{ page.name }}</router-link>
            </div>
          </div>
        </BNavbarNav>
      </BCollapse>
    </BNavbar>
    <!-- DROPDOWN MENU -->
    <div id="mainNav__dropdown">
      <button
        @mouseenter="openDropdown('User')"
        @mouseleave="delayedCloseDropdown()"
        @click="NavClicked('User')"
        class="mainNav__header user-addition"
      >
        {{ initials }}
          <font-awesome-icon v-if="hoveredDropdown == 'User' || clickedDropdown == 'User'" class="mainNav__dropdown-icon" icon="caret-up" />
          <font-awesome-icon v-else class="mainNav__dropdown-icon" icon="caret-down" />
        <div
          v-if="hoveredDropdown == 'User' || clickedDropdown == 'User'"
          id="mainNav__profile"
        >
          <router-link class="dropdown__content__item" to="/profile" @click="hoveredDropdown = null">Profile</router-link>
          <router-link class="dropdown__content__item" to="/release-notes" @click="hoveredDropdown = null">Release Notes</router-link>
          <a class="dropdown__content__item" href="https://www.barcotrucks.com/employee-feedback" target="_blank">Emp. Feedback</a>
          <a class="dropdown__content__item" href="https://payrollexperts.myisolved.com/UserLogin.aspx" target="_blank">isolved Login</a>
          <a class="dropdown__content__item" href="https://barco-live.crm.dynamics.com/" target="_blank">CRM</a>
          <a @click="logout()" class="dropdown__content__item dropdown__content__item__sign-out"
            >Sign Out</a
          >
        </div>
      </button>
    </div>
    <!-- HAMBURGER MENU -->
    <!-- <div class="right-side__items">
      <div id="mainNav__hamburgerMenu">
        <font-awesome-icon
          @click="handleHamburgerMenuToggle"
          id="mainNav__hamburgerMenu__icon"
          icon="bars"
        />
        <div id="hamburgerMenu-container" class="menu-inactive">
          <router-link
            v-if="authorizedNavLinks.includes('onboarding')"
            class="hamburgerMenu__item"
            to="/onboarding"
            @click="handleHamburgerMenuToggle"
            >On Rent</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('offboarding')"
            class="hamburgerMenu__item"
            to="/offboarding"
            @click="handleHamburgerMenuToggle"
            >Off Rent</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('transport')"
            class="hamburgerMenu__item"
            to="/transport"
            @click="handleHamburgerMenuToggle"
            >Transport</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('accounts-receivable')"
            class="hamburgerMenu__item"
            to="/accounts-receivable"
            @click="handleHamburgerMenuToggle"
            >AR</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('recon')"
            class="hamburgerMenu__item"
            to="/recon"
            @click="handleHamburgerMenuToggle"
            >Recon</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('sales')"
            class="hamburgerMenu__item"
            to="/sales"
            @click="handleHamburgerMenuToggle"
            >Sales</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('titles')"
            class="hamburgerMenu__item"
            to="/titles"
            @click="handleHamburgerMenuToggle"
            >Titles</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('monthsinfleet')"
            class="hamburgerMenu__item reporting-link"
            to="/monthsinfleet"
            >Months In Fleet</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('days-on-rent')"
            class="hamburgerMenu__item executive__item"
            to="/days-on-rent"
            >Days On Rent</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('trucks')"
            class="hamburgerMenu__item executive__item"
            to="/trucks"
            >On/Off Rent</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('on-rent-optional-services')"
            class="hamburgerMenu__item executive__item"
            to="/on-rent-optional-services"
            >On Rent Optional Services</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('bmr')
                    "
            class="hamburgerMenu__item reporting-link"
            to="/bmr"
            >BMR</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('company-report')"
            class="hamburgerMenu__item executive__item"
            to="/client-info"
            >Customer Overview</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('industry')"
            class="hamburgerMenu__item reporting-link"
            to="/industry"
            >Industry</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('fleetpie')"
            class="hamburgerMenu__item reporting-link"
            to="/fleetpie"
            >Fleet Pie</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('company-report')"
            class="hamburgerMenu__item reporting-link"
            to="/company-report"
            >Company Report</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('auction-report')"
            class="hamburgerMenu__item reporting-link"
            to="/auction-report"
            >Auction Report</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('mileage-report')"
            class="hamburgerMenu__item reporting-link"
            to="/mileage-report"
            >Mileage Report</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('accounts-receivable')"
            class="hamburgerMenu__item reporting-link"
            to="/credit-memos"
            >Credit Memos</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('invoice-report')"
            class="hamburgerMenu__item reporting-link"
            to="/invoice-report"
            >Invoice Report</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('days-in-status-report')"
            class="hamburgerMenu__item reporting-link"
            to="/days-in-status-report"
            >Days In Status</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('custom-report')"
            class="hamburgerMenu__item reporting-link"
            to="/custom-report"
            >Custom Report</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('statuscount')"
            class="hamburgerMenu__item reporting-link"
            to="/statuscount"
            >Status Count</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('status-diff')"
            class="hamburgerMenu__item reporting-link"
            to="/status-diff"
            >Status Diff</router-link
          >
           <router-link
            v-if="authorizedNavLinks.includes('company-report')"
            class="hamburgerMenu__item reporting-link"
            to="/client-info"
            >Overview</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('activity-tracker')"
            class="hamburgerMenu__item reporting-link"
            to="/activity-tracker"
            >Activity Tracker</router-link
          >
          <router-link
            v-if="authorizedNavLinks.includes('page-analytics')"
            class="hamburgerMenu__item reporting-link"
            to="/page-analytics"
            >Page Analytics</router-link
          >
          <span class="small-screen__options">
            <router-link class="hamburgerMenu__item" to="/profile">Profile</router-link>
            <router-link class="hamburgerMenu__item" to="/release-notes">Release Notes</router-link>
            <a class="hamburgerMenu__item" id="sign-out__item" @click="logout()">Sign Out</a>
            <router-link class="hamburgerMenu__item" to="https://www.barcotrucks.com/employee-feedback" target="_blank">Emp. Feedback</router-link>
            <router-link class="hamburgerMenu__item" to="https://payrollexperts.myisolved.com/UserLogin.aspx" target="_blank">isolved Login</router-link>
            <router-link class="hamburgerMenu__item" to="https://barco-live.crm.dynamics.com/" target="_blank">CRM</router-link>
          </span>
        </div>
        <div class="profile-icon" @click="handleProfileMenuToggle">
          <font-awesome-icon class="fa-lg nav__person-icon" icon="user-circle" />
          <font-awesome-icon class="fa-sm caret-icon" icon="caret-down" />
        </div>
        <div id="profileMenu-container" class="menu-inactive">
          <router-link class="profileMenu__item" to="/profile"
            @click="handleProfileMenuToggle">Profile</router-link>
          <router-link class="profileMenu__item" to="/release-notes"
            @click="handleProfileMenuToggle">Release Notes</router-link>
          <router-link class="profileMenu__item" to="https://www.barcotrucks.com/employee-feedback" target="_blank"
            @click="handleProfileMenuToggle">Employee Feedback</router-link>
          <router-link class="profileMenu__item" to="https://payrollexperts.myisolved.com/UserLogin.aspx" target="_blank"
            @click="handleProfileMenuToggle">isolved Login</router-link>
          <router-link class="profileMenu__item" to="https://barco-live.crm.dynamics.com/" target="_blank"
            @click="handleProfileMenuToggle">CRM</router-link>
          <a class="profileMenu__item" id="sign-out__item" @click="logout()">Sign Out</a>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import auth from '../utils/auth/permissionRules';
import { mapGetters, mapActions } from 'vuex';
import constants from '@/assets/constants';
import axios from 'axios';
import variables from '../assets/scss/base/_variables.scss';

export default {
  name: 'Navbar',
  data() {
    return {
      executiveTabNamesArr: [
        'owners-stats',
        'fleetcard',
        'employee-management',
        'truck-details',
        'profit-loss',
        'manheim-listings',
        'activity-tracker'
      ],
      reportTabNamesArr: [
        'monthsinfleet',
        'bmr',
        'statuscount',
        'daily-counts',
        'industry',
        'fleetpie',
        'company-report',
        'auction-report',
        'mileage-report',
        'miles-over-report',
        'credit-memos',
        'invoice-report',
        'days-in-status-report',
        'custom-report',
        'truck-count-by-state',
        'lot-auction-count'
      ],
      dropdownActive: false,
      shouldDisplay: false,
      navColor: null,
      // authorizedNavLinks: [],
      // isMobileMenuOpen: false,
      executiveHover: false,
      reportsHover: false,
      formsHover: false,
      rentalHover: false,
      userHover: false,
      fleetHover: false,
      companyOverHover: false,
      aRHover: false,
      initials: '',
      notFoundPath: '',
      navbarColorLoaded: false,
      employeePermissions: [],
      ownerPermissions: [],
      hoveredDropdown: null,
      clickedDropdown: null,
      dropdownTimeout: null,
      subDropdownTimeout: null,
      frequentPages: [
        { label: 'Rental', 
          pages: [ 
            { name: 'On Rent', href: '/onboarding', permissions: ['onboarding'] },
            { name: 'Off Rent', href: '/offboarding', permissions: ['offboarding'] }
          ]
        },
        { name: 'Transport', href: '/transport', permissions: ['transport'] },
        { name: 'AR', href: '/accounts-receivable', permissions: ['accounts-receivable'] },
        { name: 'Recon', href: '/recon', permissions: ['recon'] },
        { name: 'Service', href: '/service', permissions: ['service-page'] },
        { name: 'Sales', href: '/sales', permissions: ['sales'] },
        { name: 'Titles', href: '/titles', permissions: ['titles'] },
      ],
      groupedPages: [
        {
          label: 'Forms',
          columns: [
            {
              header: '',
              pages: [
                { name: 'Order Form', href: '/order-form', newTab: true },
                { name: 'Trade Form', href: '/trade-form', newTab: true },
                { name: 'Off Rent Form', href: '/off-rent-form', newTab: true }
              ]
            }
          ]
        },
        {
          label: 'Executive',
          columns: [
            {
              header: 'Management',
              pages: [
                { name: 'Employees', href: '/employee-management', permissions: ['employee-management'] },
                { name: 'Fleet Card', href: '/fleetcard', permissions: ['fleetcard'] },
                { name: 'Owners Stats', href: '/owners-stats', permissions: ['owners-stats-user-id'] }
              ],
            },
            {
              header: 'Financial',
              divider: false,
              pages: [
                { name: 'Manheim Listings', href: '/manheim-listings', permissions: ['manheim-listings'] },
                { name: 'Profit/Loss', href: '/profit-loss', permissions: ['profit-loss'] },
                { name: 'Truck Details', href: '/truck-details', permissions: ['truck-details'] }
              ],
            },
            {
              header: 'Activity',
              divider: true,
              pages: [
                { name: 'Activity Tracker', href: '/activity-tracker', permissions: ['activity-tracker'] },
                { name: 'Page Analytics', href: '/page-analytics', permissions: ['page-analytics'] }
              ]
            }
          ],
        },
        {
          label: 'Reporting',
          columns: [
            {
              header: 'AR',
              pages: [
                { name: 'AR Counts', href: '/ar-counts', permissions: ['ar-counts'] },
                { name: 'Billing', href: '/billing', permissions: ['billing'] },
                { name: 'Credit Memos', href: '/credit-memos', permissions: ['credit-memos'] },
                { name: 'Custom Report', href: '/custom-report', permissions: ['custom-report'] },
                { name: 'Days In Status', href: '/days-in-status-report', permissions: ['days-in-status-report'] },
                { name: 'Invoice Report', href: '/invoice-report', permissions: ['invoice-report'] }
              ],
            },
            {
              header: 'Operations',
              divider: true,
              pages: [
                // { name: 'Auction Report', href: '/auction-report', permissions: ['auction-report'] },
                { name: 'BMR', href: '/bmr', permissions: ['bmr'] },
                { name: 'Customer Overview', href: '/client-info', permissions: ['company-report'] },
                { name: 'Days On Rent', href: '/days-on-rent', permissions: ['days-on-rent-report'] },
                { name: 'Fleet Pie', href: '/fleetpie', permissions: ['fleetpie'] },
                { name: 'Industry', href: '/industry', permissions: ['industry'] },
                { name: 'Lot & Auction Count', href: '/lot-auction-count', permissions: ['lot-auction-count', 'new-trade-counts', 'new-only-counts'] },
                { name: 'Mileage Report', href: '/mileage-report', permissions: ['mileage-report'] },
                { name: 'Miles Over', href: '/miles-over-report', permissions: ['miles-over-report'] },
                { name: 'Months In Fleet', href: '/monthsinfleet', permissions: ['monthsinfleet'] },
                { name: 'On/Off Rent', href: '/trucks', permissions: ['trucks'] },
                { name: 'On Rent Optional Services', href: '/on-rent-optional-services', permissions: ['on-rent-optional-services'] },
                { name: 'Status Count', href: '/statuscount', permissions: ['statuscount'] },
                { name: 'Status Diff', href: '/status-diff', permissions: ['status-diff'] },
                { name: 'Status Management', href: '/status-management', permissions: ['status-management'] },
                { name: 'Truck Count By State', href: '/truck-count-by-state-new', permissions: ['truck-count-by-state'] },
                { name: 'Unit Hub', href: '/unit-hub', permissions: ['unit-hub'] },
                { name: 'Variables List', href: '/stored-variables', permissions: ['stored-variables'] }
              ],
            },
          ]
        }
      ]
    };
  },
  watch: {
    $route(to, from) {
      // let domain = window.location.hostname;
      const tokenPayload = localStorage.getItem('token')
        ? localStorage.getItem('token').split(' ')[1]
        : '';
      if (!this.navbarColorLoaded && this.$route.name != undefined && this.$route.name != 'notFound') {
        let currentPath = window.location.pathname;
        if (currentPath != '/employee-login' && currentPath != '/order-form' && currentPath != '/trade-form' && currentPath != '/off-rent-form') {
          this.navbarShouldDisplay();
          this.getVariablePermissions();
        }
      }
      if (from && from.name == 'accounts-receivable') {
        from.name = 'ar';
      }
      if (to && to.name == 'accounts-receivable') {
        to.name = 'ar';
      }
      if (this.$socket && from && from.name && from.name !== to.name) {
        this.$socket.emit('leaveRoom', from.name);
      }
      if (this.$socket && to && to.name && tokenPayload != '') {
        this.$socket.emit('joinRoom', { roomName: to.name, token: tokenPayload });
      } else if (this.$socket && to && to.name) {
        if (this.authorizedNavLinks.length === 0) {
          if (this.$socket && localStorage.getItem('token')) {
            this.$socket.emit('joinRoom', { roomName: to.name, token: tokenPayload });
            // this.$socket.emit('assignGroups', tokenPayload);
          } else {
            console.error('Socket not available');
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters(['getUserInfo']),

    authorizedNavLinks() {
      return auth.permittedNavLink();
    },
    filteredGroupedPages() {
      return this.groupedPages
        .map(group => {
          if (group.label === "Reporting") {
            const columns = [];

            const scheduledColumn = group.columns.find(c => c.header === "AR");
            if (scheduledColumn) {
              const scheduledItems = scheduledColumn.pages.filter(item =>
                item.permissions.some(perm => this.authorizedNavLinks.includes(perm)) || item.permissions == null || this.ownerPermissions.includes(this.getUserInfo.UserID)
              );
              if (scheduledItems.length) {
                columns.push({
                  header: scheduledColumn.header,
                  pages: scheduledItems
                });
              }
            }

            const customColumn = group.columns.find(c => c.header === "Operations");
            if (customColumn) {
              const customItems = customColumn.pages.filter(item =>
                item.permissions.some(perm => this.authorizedNavLinks.includes(perm)) || item.permissions == null || this.ownerPermissions.includes(this.getUserInfo.UserID)
              );
              if (customItems.length) {
                const splitCustomColumns = this.splitIntoColumns(customItems, 3).map((pages, index) => ({
                  header: index === 0 ? 'Operations' : '-',
                  divider: index === 0,
                  pages
                }));
                columns.push( ...splitCustomColumns );
              }
            }
            return columns.length ? { label: group.label, columns } : null;
          } else {
            const filteredColumns = group.columns.map(col => {
              const filteredItems = col.pages.filter(item =>
                (item && item.permissions && item.permissions.some(perm => this.authorizedNavLinks.includes(perm))) || item.permissions == null || this.ownerPermissions.includes(this.getUserInfo.UserID)
              );
              return filteredItems.length
                ? {
                    header: col.header,
                    pages: filteredItems,
                    divider: col.divider
                  }
                : null;
            }).filter(c => c !== null);

            if (this.authorizedNavLinks.includes('employee-management') ||
                this.authorizedNavLinks.includes('fleetcard') ||
                this.authorizedNavLinks.includes('owners-stats-user-id')) {
              if (group.label === 'Executive') {
                filteredColumns.find(c => c.header === 'Financial').divider = true;
              }
            }

            return filteredColumns.length ? { label: group.label, columns: filteredColumns } : null;
          }
        })
        .filter(g => g !== null);
    },
    filteredMobilePages() {
      const pages = this.frequentPages.filter(page =>
        page.permissions && page.permissions.some(perm => this.authorizedNavLinks.includes(perm))
      );
      this.frequentPages.forEach(group => {
        if (group.pages) {
          group.pages.forEach(page => {
            if (page.permissions && page.permissions.some(perm => this.authorizedNavLinks.includes(perm))) {
              pages.push({
                ...page
              })
            }
          })
        }
      });
      this.groupedPages.forEach(group => {
        group.columns.forEach(column => {
          column.pages.forEach(page => {
            if (page.permissions && page.permissions.some(perm => this.authorizedNavLinks.includes(perm))) {
              pages.push({
                ...page,
                group: group.label,
                header: column.header
              });
            }
          });
        });
      });

      return pages.sort((a, b) => a.name.localeCompare(b.name));
    }
  },
  async created() {
    if (localStorage.getItem('token')) {
      this.fetchUserInfo();
      setTimeout(() => {
        if (this.getUserInfo && this.getUserInfo.FirstName) {
          this.initials = this.getUserInfo.FirstName.substring(0, 1) + this.getUserInfo.LastName.substring(0, 1);
        } else {
          this.initials = 'User';
        }
      }, 1000);
    } 
    let domain = window.location.hostname;
    if (!this.navbarColorLoaded && this.$route.name != undefined && this.$route.name != 'notFound') {
      let currentPath = window.location.pathname;
      if (currentPath != '/employee-login' && currentPath != '/order-form' && currentPath != '/trade-form' && currentPath != '/off-rent-form') {
        await this.navbarShouldDisplay();
        await this.getVariablePermissions();
      }
    }
  },
  mounted() {
    let domain = window.location.hostname;
    if (!this.navbarColorLoaded  && this.$route.name != undefined && this.$route.name != 'notFound') {
      let currentPath = window.location.pathname;
      // if (currentPath != '/employee-login' && currentPath != '/order-form' && 
      //   currentPath != '/trade-form' && currentPath != '/off-rent-form') {
      //   axios
      //   .get(`${constants.BASE_URL}/getDataSource`, {
      //     headers: { Authorization: localStorage.getItem('token') },
      //   })
      //   .then(result => {
      //     if (result.data == 'local') {
      //       if (localStorage.getItem('impersonating') == 'true') {
      //         document.getElementById('mainNav').style.backgroundColor = 'rgb(255, 50, 100)';
      //       } else {
      //         document.getElementById('mainNav').style.backgroundColor = 'rgb(3, 76, 25)';
      //       }
      //     } else if (result.data == 'test') {
      //       if (localStorage.getItem('impersonating') == 'true') {
      //         document.getElementById('mainNav').style.backgroundColor = 'rgb(255, 50, 100)';
      //       } else {
      //         document.getElementById('mainNav').style.backgroundColor = 'rgb(185, 50, 0)';
      //       }
      //     } else if (localStorage.getItem('impersonating') == 'true') {
      //       document.getElementById('mainNav').style.backgroundColor = 'rgb(255, 50, 100)';
      //     }
      //     this.navbarColorLoaded = true;
      //   }).catch(err => {
      //     console.log('Token has expired, please login again');
      //   })
      // }
    }
  },
  methods: {
    ...mapActions(['logout', 'fetchUserInfo']),

    handleDropdownTrans() {
      this.dropdownActive = !this.dropdownActive;
    },
    handleHamburgerMenuToggle() {
      document.getElementById('profileMenu-container').classList.remove('profileMenu-active');
      document.getElementById('profileMenu-container').classList.add('menu-inactive');
      document.getElementById('hamburgerMenu-container').classList.remove('menu-inactive');
      setTimeout(function() { document.getElementById('hamburgerMenu-container').classList.toggle('hamburgerMenu-active'); 
        if (!document.getElementById('hamburgerMenu-container').classList.contains('hamburgerMenu-active')) {
          setTimeout(function() { document.getElementById('hamburgerMenu-container').classList.add('menu-inactive') }, 225);
        }}, 25);
    },
    handleProfileMenuToggle() {
      document.getElementById('hamburgerMenu-container').classList.remove('hamburgerMenu-active');
      document.getElementById('hamburgerMenu-container').classList.add('menu-inactive');
      document.getElementById('profileMenu-container').classList.remove('menu-inactive');
      setTimeout(function() { document.getElementById('profileMenu-container').classList.toggle('profileMenu-active'); 
        if (!document.getElementById('profileMenu-container').classList.contains('profileMenu-active')) {
          setTimeout(function() { document.getElementById('profileMenu-container').classList.add('menu-inactive') }, 225);
        }}, 25);
    },
    async navbarShouldDisplay() {
      const dismissNavRoutes = [
        'orderForm',
        'offRentForm',
        'login',
        'employee-login',
        'DamageForm',
        'Register',
        'passwordResetExternal',
        'documentation',
        'tradeForm',
        'notFound'
      ];

      if (!localStorage.getItem('token') || dismissNavRoutes.includes(this.$route.name)) {
        return (this.shouldDisplay = false);
      }
      await axios
      .get(`${constants.BASE_URL}/getDataSource`, {
        headers: { Authorization: localStorage.getItem('token') },
      })
      .then(result => {
        const impersonating = localStorage.getItem('impersonating') === 'true';
        if (result.data == 'local') {
          this.navColor = impersonating
            ? 'rgb(255, 50, 100)'
            : 'rgb(3, 76, 25)';
        } else if (result.data == 'test') {
          this.navColor = impersonating
            ? 'rgb(255, 50, 100)'
            : 'rgb(185, 50, 0)';
        } else {
          this.navColor = impersonating
            ? 'rgb(255, 50, 100)'
            : 'rgb(0, 0, 0)';
        } 
        this.navbarColorLoaded = true;
      }).catch(err => {
        console.log('Data Source Error: ', err);
      })

      return (this.shouldDisplay = true);
    },
    async getVariablePermissions() {
      await axios.get(`${constants.BASE_URL}/api/variables/get-variables`, { params: { Group: 'Software' } })
        .then(result => {
          let vars = result.data;
          for (let i = 0; i < vars.length; i++) {
            if (vars[i].VariableName == 'Owners Stats Permissions') {
              this.ownerPermissions = vars[i].VariableValue.split(",").map(Number);
            } else if (vars[i].VariableName == 'Employee Management Permissions') {
              this.employeePermissions = vars[i].VariableValue;
            }
          }
        }).catch(err => {
          if (err && err.response && err.response.status === 403) {
            this.showLogOutModal = true;
          } else {
            console.log(err);
          }
        })
    },
    // async getNavLinks() {
    //   const navLinks = auth.permittedNavLink();
    //   this.authorizedNavLinks = navLinks;
    // },
    NavClicked(nav) {
      if (window.matchMedia("(pointer: coarse)").matches) {
        if (this.clickedDropdown && this.clickedDropdown == nav) {
          this.clickedDropdown = null;
          this.hoveredDropdown = null;
        } else {
          this.clickedDropdown = nav;
          this.hoveredDropdown = null;
        }
      }
    },
    closeUserNav() {
      this.clickedDropdown = null;
    },
    clickHamburger() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    openDropdown(d) {
      if (!window.matchMedia("(pointer: coarse)").matches) {
        clearTimeout(this.dropdownTimeout);
        this.hoveredDropdown = d;
        if (d !== 'User') {
          this.clickedDropdown = null;
        }
      }
    },
    delayedCloseDropdown() {
      if (!window.matchMedia("(pointer: coarse)").matches) {
        this.dropdownTimeout = setTimeout(() => {
          this.hoveredDropdown = null;
          this.clickedDropdown = null;
        }, 1000);
      }
    },
    openSubDropdown(sd) {
      clearTimeout(this.subDropdownTimeout) 
      if (sd == 'ar') {
        this.aRHover = true;
        this.companyOverHover = false;
      } else if (sd == 'operations') {
        this.companyOverHover = true;
        this.aRHover = false;
      }
    },
    delayedCloseSubDropdown() {
      this.subDropdownTimeout = setTimeout(() => {
        this.aRHover = false;
        this.companyOverHover = false;
      }, 1000);
    },
    splitIntoColumns(items, numberOfColumns) {
      const columns = Array.from({ length: numberOfColumns }, () => []);
      items.forEach((item, index) => {
        columns[index % numberOfColumns].push(item);
      });
      return columns;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/index.scss';
#mainNav {
  // position relative fixed it
  position: sticky;
  top: 0;
  z-index: 20;
  height: 50px;
  width: 100%;
  background: $navbarBgColor;
  @include F($j: space-between);
  padding: 0 5px;
  color: $navbarTextColor;
  font-family: $primaryFont;
  font-weight: 500;
  -webkit-box-shadow: 0px 2px 7px -3px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 7px -3px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 7px -3px rgba(0, 0, 0, 0.75);
}
// [data-url*="localhost"] #mainNav {
//    background: rgb(3, 76, 25);    
// }
#mainNav__logo {
  height: 55px;
  width: 85px;
  padding: 5px;
  margin-left: 5px;
  img {
    height: 100%;
  }
}
nav {
  height: 100%;
  width: 100%;
}
.mainNav__item {
  background: none;
  border: none;
  @include F(flex-start);
  transition: opacity 0.3s ease-in-out;
  text-decoration: none;
  color: $navbarTextColor;
  text-align: start;
  // height: 100%;
  padding: 12px;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.5px;
  white-space: nowrap;
  &:hover {
    color: var(--barco-hover-color) !important;
  }
}
.mainNav__header {
  background: none;
  border: none;
  @include F(flex-start);
  transition: opacity 0.3s ease-in-out;
  text-decoration: none;
  color: $navbarTextColor;
  text-align: start;
  // height: 100%;
  padding: 12px;
  font-size: 1.1rem;
  font-weight: 400;
  letter-spacing: 0.5px;
  white-space: nowrap;
  &:hover {
    color: var(--barco-hover-color) !important;
  }
}

.mainNav__dropdown-icon {
  margin: 0 5px;
}

button {
  position: relative;
}

#mainNav__executive {
  // width: 550px;
  position: absolute;
  top: 99%;
  left: 0%;
  background: #0f0f10;
  border: 1px solid #333333;
  border-radius: 10px;
  // background: $navbarBgColor;
  padding: 10px 0;
  text-align: start;
  display: flex;
  flex-direction: row;
}

#mainNav__rental {
  position: absolute;
  top: 99%;
  left: 0%;
  background: #0f0f10;
  border: 1px solid #333333;
  border-radius: 10px;
  // background: $navbarBgColor;
  padding: 10px 0;
  text-align: start;
  display: flex;
  flex-direction: column;
}

#mainNav__profile {
  width: 200px;
  position: absolute;
  top: 99%;
  right: 0%;
  // background: $navbarBgColor;
  background: #0f0f10;
  border: 1px solid #333333;
  border-radius: 10px;
  padding: 10px 0;
  text-align: start;
}

.user-addition {
  margin-right: 5px;
}

.executive__item {
  padding: 10px 20px !important;
  display: block !important;
  width: 100%;
  text-align: left;
}

.hamburgerMenu__item.executive__item {
  padding: 10px 20px !important;
}

.router-link-exact-active {
  min-width: 100px;
  height: 42px;
  // top: 4px;
  position: relative;
  border-radius: 4px;
  color: $navbarTextColor !important;
  // background: #6C757D;
  // background: linear-gradient(65deg, rgba(27, 68, 149, 0.9), rgba(27, 149, 188, 0.9));
  // background: linear-gradient(65deg, rgba(6, 77, 10, 0.9), rgba(210, 235, 212, 0.9));
  // background: linear-gradient(45deg, rgb(98 104 109 / 50%), rgb(199 206 212 / 80%)),
  //             linear-gradient(320deg, rgb(89 94 99 / 50%), rgb(228 237 245 / 80%));
  background: radial-gradient(ellipse at 50% 0, rgb(199 206 212), rgb(79, 84, 88));
  &:hover {
    color: white !important;
  }
}

.home-link {
  background: none;
}
// .router-link-exact-active:hover {
//   color: $navbarTextColor !important;
//   background: rgb(97, 105, 112);
// }

#mainNav__dropdown {
  position: relative;
  height: 100%;
  padding: 0 5px;
  &:hover {
    cursor: pointer;
  }
}
#dropdown__title {
  @include F();
  height: 100%;
  h3 {
    font-size: 1.2rem;
    margin: 0 5px;
  }
}
.dropdown-active {
  transform: translateX(0%) !important;
  #dropdown__title__icon {
    color: red !important;
  }
}
#dropdown__content {
  transform: translateX(110%);
  transition: 300ms ease-in-out transform;
  background: #111;
  position: absolute;
  top: 55px;
  right: 0;
  padding: 10px 0;
  border-radius: 0.4rem;
  overflow: hidden;
  width: 12rem;
  h3 {
    margin: 0 5px;
  }
  #dropdown__title__icon {
    transform: rotate(45deg);
  }
}
.dropdown__content__item {
  font-size: 1rem;
  font-weight: 400;
  text-decoration: none;
  color: $navbarTextColor;
  width: 100%;
  @include F($j: flex-start);
  margin: 0;
  padding: 10px 5px 10px 15px;
  &:hover {
    color: var(--barco-hover-color);
  }
}

.dropdown__content__item__sign-out {
  &:hover {
    color: var(--barco-hover-color);
  }
}

// Hamburger Custom Styles

#mainNav__hamburgerMenu__icon {
  margin: 0 10px 0 0;
  height: 33px;
  width: 33px;
  font-size: 2rem;
  padding: 4px 8px;
  color: white;
  &:hover {
    cursor: pointer;
    border-radius: 3px;
    background-color: #272727;
  }
}

#mainNav__hamburgerMenu {
  display: flex;
}

#hamburgerMenu-container {
  @include F(flex-start, flex-start, column);
  position: absolute;
  right: -133px;
  top: 53px;
  background: $navbarBgColor;
  border-radius: 0.2rem;
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 86vh;
  transition: right 200ms ease-in-out;
}

.hamburgerMenu-active {
  right: 3px !important;
}
.menu-inactive {
  display: none !important;
}

.small-screen__options {
  display: none;
}

.hamburgerMenu__item {
  font-size: 0.9rem;
  text-decoration: none;
  color: $navbarTextColor;
  width: 100%;
  @include F($j: flex-start);
  margin: 0;
  padding: 10px 20px;
  &:hover {
    background: $barcoLightBlueFont;
  }
}

a.hamburgerMenu__item.reporting-link {
  display: none;
}

#profileMenu-container {
  @include F(flex-start, flex-start, column);
  position: absolute;
  right: -123px;
  top: 53px;
  background: $navbarBgColor;
  border-radius: 0.2rem;
  overflow: hidden;
  transition: right 200ms ease-in-out;
}

.profileMenu-active {
  right: 3px !important;
}

.profileMenu__item {
  font-size: 0.9rem;
  text-decoration: none;
  color: $navbarTextColor;
  width: 100%;
  @include F($j: flex-start);
  margin: 0;
  padding: 15px 10px 15px 15px;
  &:hover {
    background: $barcoLightBlueFont;
  }
}

.left-items, .mid-items {
  display: flex;
  .nav__dropdown--options {
    display: flex;
    height: 100%;
  }
}

.mainNav__header {
  // padding-right: 20px;
  &.router-link-exact-active {
    height: 42px;
    margin-top: 4px;
    @include F();
  }
}

#sign-out__item {
  font-size: 0.9rem;
  text-decoration: none;
  color: $navbarTextColor;
  width: 100%;
  @include F($j: flex-start);
  margin: 0;
  padding: 15px 10px 15px 15px;
  &:hover {
    color: $navbarTextColor;
  }
}

.nav__person-icon {
  margin-right: 10px;
}

.right-side__items {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .profile-icon {
    height: 33px;
    width: 50px;
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    transition: background-color 0.15s;
    cursor: pointer;
    .caret-icon {
      margin-left: -20px;
    }
  }

  .profile-icon:hover {
    background-color: #272727;
    border-radius: 3px;
  }
}
.mega-menu-header {
  color: white;
  height: 15px;
  font-weight: bold;
  margin-left: 20px;
  margin-bottom: 2px;
  font-size: .7rem;
  opacity: .5;
}

// .mega-menu-divider {
//   height: 1px;
//   background-color: var(--bs-border-color, #ccc);
//   margin-bottom: 0.75rem;

// }
.mega-menu-column.with-divider {
  border-left: 1px solid rgba(250, 250, 250, .3);
  margin-left: 1rem;
  padding-left: 1rem;
}

.animated.fadeIn {
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

// Media Queries
//Make the menu shrink earlier

@media screen and (max-width: 1650px) {
  nav {
    display: none;
  }

  // #mainNav__dropdown {
  //   display: none;
  // }

  #mainNav__hamburgerMenu {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .nav__barco--logo {
    display: inline;
  }
}

@media screen and (min-width: 1651px) {
  .right-side__items {
    display: none;
  }
}

@media screen and (max-width: 1111px) {
  .mainNav__item {
    font-size: .8rem;
  }
}

@media screen and (max-width: 912px) {
  .dropdown__content__item {
    font-size: 0.9rem;
    font-weight: 600;
    margin: 0;
    padding: 10px 5px 10px 15px;
  }
  #dropdown__title {
    h3 {
      font-size: 0.9rem;
      font-weight: 600;
    }
  }
  // .mainNav__item, .mainNav__header {
  //   font-size: 0.9rem;
  //   font-weight: 600;
  //   padding: 0 10px;
  // }
}

@media screen and (max-width: 650px) {
  // nav {
  //   display: none;
  // }

  // #mainNav__dropdown {
  //   display: none;
  // }

  #mainNav__hamburgerMenu {
    display: flex;
  }
}

@media screen and (max-width: 500px) {
  .reporting-button {
    display: none;
  }
  a.hamburgerMenu__item.reporting-link {
    display: flex;
  }
}
@media screen and (max-width: 430px) {
  // .profile-icon {
  //   display: none !important;
  // }

  .small-screen__options {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  // #profileMenu-container {
  //   display: none;
  // }
}

@media print {
  #mainNav {
    display: none;
  }
}

.fleet__item {
  background-color: #0f0f10;
  border: 1px solid #333333;
  border-radius: 10px;
  margin-left: 178px;
  margin-top: -46px;
  padding: 10px 0px;
  min-width: 220px;
  max-width: 300px;
  overflow-y: hidden;
  position: absolute;
}
@media screen and (max-height: 777px) {
  .fleet__item {
    display: flex;
    flex-wrap: wrap;
    overflow-y: scroll;
    max-height: 90vh;
  }
}

.caret {
  margin-left: 0.5rem;
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-left: 0.3em solid transparent;
  display: inline-block;
  vertical-align: middle;
}

.dark-mode {
  --bs-body-bg: #222;
  --bs-body-color: #fff;
  --bs-navbar-bg: #333;
  --bs-dropdown-bg: #444;
}

.light-mode {
  --bs-body-bg: #fff;
  --bs-body-color: #212529;
  --bs-navbar-bg: #0d6efd;
  --bs-dropdown-bg: #fff;
}

.mainNav__rental #mainNav__executive {
  flex-direction: column;
  min-width: 150px;
}
// @keyframes slideOutToLeft {
//   from {
//     transform: translateX(0);
//   }
//   to {
//     transform: translateX(-100%);
//   }
// }
@media (max-width: 991.98px) {
  #mainNav__logo {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
  .nav__barco--logo {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  // .mobile-slide-out .dropdown-menu {
  //   animation: slideOutToLeft 3s ease forwards;
  // }
}
</style>
